import { render, staticRenderFns } from "./member_integal.vue?vue&type=template&id=0f19da64&"
import script from "./member_integal.vue?vue&type=script&lang=js&"
export * from "./member_integal.vue?vue&type=script&lang=js&"
import style0 from "./member_integal.vue?vue&type=style&index=0&id=0f19da64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports